<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Introdução
      </h2>
      <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
        Olá! Na janela “Relatórios Gerais” do Monitoramento do Perfil você encontra quatro abas:
      </p>
      <div class="d-flex justify-space-around">
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          1. <b>Perfil dos Servidores</b><br>
          2. <b>Participação Geral</b>
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          3. <b>Relatórios Gerenciais</b><br>
          4. <b>Relatórios Gerenciais por Unidade</b>
        </p>
      </div>
    </div>

    <div>
      <h2>
        1. Perfil dos Servidores
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba 1. “Perfil dos servidores” você encontra dois tipos de filtros:
        </p>
        <div class="d-flex justify-space-around">
          <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
            1. <b>Unidade</b>
          </p>
          <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
            2. <b>Servidores</b>
          </p>
        </div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro “Unidade”, você encontra todas as unidades disponíveis para sua pesquisa,
          incluindo as unidades hierarquicamente vinculadas a sua. No filtro “Servidores” você
          encontra os membros da equipe da unidade selecionada. Ao selecionar um servidor, é
          possível analisar, o seu perfil por meio dos dados preenchidos no sistema Desenvolva.
        </p>
      </div>
    </div>

    <div>
      <h2>
        2. Participação Geral
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba 2 “Participação geral”, inicialmente, você realiza a seleção da(s) unidade(s),
          utilizando os seguintes recursos:
          <ul>
            <li>
              <p class="text-start font-weight-medium text-lg-h6">
                Selecionar todos: seleciona todas as unidades disponíveis para sua pesquisa,
                incluindo as unidades hierarquicamente vinculadas a sua.
              </p>
            </li>
            <li>
              <p class="text-start font-weight-medium text-lg-h6">
                Expandir lista: apresenta todas as unidades disponíveis para sua pesquisa,
                incluindo as unidades hierarquicamente vinculadas a sua.
              </p>
            </li>
            <li>
              <p class="text-start font-weight-medium text-lg-h6">
                Categoria: possibilita selecionar as categorias: “Gestores”, “Servidores” ou
                “Todos”, para verificar a participação de cada categoria no módulo “Perfil”.
              </p>
            </li>
          </ul>
        </p>
      </div>
    </div>

    <div>
      <h2>
        2. Participação Geral
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Ao lado das “Unidades”, estão disponíveis os recursos para expansão e seleção
          individual, bem como, a opção de selecionar todas as unidades hierarquicamente
          vinculadas.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          A opção “Pesquisar” está disponível para facilitar a busca por unidade específica.
          Após selecionados os filtros para pesquisa, clique no botão “pesquisar” ao final
          da página. Na sequência, aparecerão dados expostos por meio de gráficos e tabelas
          sobre a participação dos servidores no módulo “Perfil”.
        </p>
      </div>
    </div>

    <div>
      <h2>
        Gráficos e Tabelas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          O gráfico “Participação Geral do Perfil” apresenta o percentual dos servidores que
          concluíram o preenchimento das abas do módulo “Perfil”, considerando a(s) unidade(s)
          selecionada(s).
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          A tabela “Quadro resumo do perfil” apresenta: a(s) unidade(s), o total de servidores,
          o número de pendentes, o número de concluídos e o percentual de conclusão da unidade.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          A tabela “Resultados” apresenta: os servidores, a unidade, a indicação de preenchimento
          de cada aba do módulo “Perfil” e a “situação” (pendente ou concluído).
        </p>
      </div>
    </div>

    <div>
      <h2>
        3. Relatórios Gerenciais
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba 3. “Relatórios Gerenciais” você encontra dois tipos de filtros:
        </p>
        <div class="d-flex justify-space-around">
          <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
            1. <b>Tipo de Monitoramento</b>
          </p>
          <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
            2. <b>Seleção das Unidades</b>
          </p>
        </div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro “Tipo de Monitoramento”, você encontra as opções: cadastro, formação,
          atuação profissional, atividades de interesse e preferências de trabalho.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro “Seleção das Unidades”, você encontra todas as unidades disponíveis para sua
          pesquisa, incluindo as unidades hierarquicamente vinculadas a sua.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Após selecionados os filtros para pesquisa, clique no botão “pesquisar” ao final da página.
          Na sequência, aparecerão dados expostos por meio de gráficos e tabelas sobre a participação
          da(s) <b>unidade(s)</b> no módulo “Perfil”.
        </p>
      </div>
    </div>

    <div>
      <h2>
        3. Relatórios Gerenciais por Unidade
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba 4. “Relatórios Gerenciais por Unidade” você encontra dois tipos de filtros:
        </p>
        <div class="d-flex justify-space-around">
          <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
            1. <b>Tipo de Monitoramento</b>
          </p>
          <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
            2. <b>Unidade</b>
          </p>
        </div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro “Tipo de Monitoramento”, você encontra as opções: cadastro, formação,
          atuação profissional, atividades de interesse e preferências de trabalho.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro “Unidade”, você encontra todas as unidades disponíveis para sua pesquisa,
          incluindo as unidades hierarquicamente vinculadas a sua.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Após selecionados os filtros para pesquisa, clique no botão “pesquisar” ao final da página.
          Na sequência, aparecerão dados expostos por meio de gráficos e tabelas sobre a participação
          dos <b>servidores</b> no módulo “Perfil”.
        </p>
      </div>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-2 pa-2 justify-center">
        <ul>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar a aba “Perfil dos servidores”, para conhecer o perfil de cada
              servidor por meio dos dados preenchidos no sistema Desenvolva.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar a aba “Participação geral”, para monitorar a participação dos
              servidores no módulo Perfil.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar a aba “Relatórios Gerenciais”, para visualizar os dados cadastrados
              no módulo Perfil, compilados por unidade.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar a aba “Relatórios Gerenciais por Unidade”, para visualizar os dados
              cadastrados pelos servidores no módulo Perfil.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              O Gestor pode trabalhar os dados preenchidos pelos servidores, no módulo “Perfil”,
              para ampliar seu conhecimento sobre eles, no intuito de viabilizar ações para melhor
              adaptá-los ao ambiente de trabalho.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Você pode imprimir todos os resultados na opção baixar PDF.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../../BaseTutorial';

export default {
  name: 'TutorialMonitoramentoPerfilRelatoriosGerenciais',

  components: { BaseTutorial },

  data() {
    return {
      steps: [
        'Introdução',
        'Perfil dos Servidores',
        'Participação Geral',
        'Paricipação Geral',
        'Gráficos e Tabelas',
        'Relatórios Gerenciais',
        'Relatórios Gerenciais por Unidade',
        'Importante',
      ],
    };
  },
};
</script>
